import React, { useEffect, useState } from 'react';

// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';

import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import { Assignment, Done, Search } from '@material-ui/icons';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import Button from 'components/CustomButtons/Button';

import ModalFull from 'components/Tvendo/Common/ModalFull';
import { WithApp } from 'contexts/appContext';
import { wsFindBy } from 'services/WService';
import {
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Radio,
  Select,
  TextField,
} from '@material-ui/core';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
  },
};
const useStyles = makeStyles(styles);

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false },
  { Header: 'Código', accessor: 'CardCode' },
  { Header: 'Nombre cliente', accessor: 'CardName' },
  { Header: 'RUC/DNI', accessor: 'LicTradNum' },
  { Header: 'Dirección', accessor: 'Address2' },
  { Header: 'Estado', accessor: 'state' },
  { Header: '', accessor: 'actions', excelEnabled: false },
];

export default WithApp(function ModalFilterCustomer(props) {
  const classes = useStyles();
  const { open, setOpen, saleType, dataSale, changeDataSale, entity, cardType, extraFilters } = props;
  const { zones = [] } = props;
  const { deliveryType = 'D' } = props;
  const [customerListType, setCustomerListType] = useState('S'); // S => Seller, T => Todo
  const [searchState, setSearchState] = useState('');
  const [selectedZone, setSelectedZone] = useState();

  const [customers, setCustomers] = useState([]);

  /**
   * Filtra clientes basado en letras iniciales permitidas
   * @param {Array} customerList - Lista de clientes a filtrar
   * @returns {Array} - Lista filtrada
   */
  function filterByAllowedLetters(customerList) {
    if (!extraFilters?.firstLetterRestriction || extraFilters.firstLetterRestriction.length === 0) {
      return customerList;
    }

    const allowedLetters = extraFilters.firstLetterRestriction.map(letter => letter.toUpperCase());
    
    return customerList.filter(customer => {
      const firstLetter = customer.CardCode?.charAt(0).toUpperCase();
      return allowedLetters.includes(firstLetter);
    });
  }

  async function listCustomers(search) {
    setCustomers([]);
    let filter = {
      CardType: 'C',
      base_zone_id: search.base_zone_id,
      base_seller_id: search.base_seller_id,
    };
    if(cardType !== undefined){
      filter.CardType = cardType;
    }
    if (saleType === 'O') delete filter.base_seller_id;
    if (customerListType === 'T') {
      let zone = selectedZone || dataSale.base_zone_id;
      if (zone === undefined) return;
      delete filter.base_zone_id;
      delete filter.base_seller_id;
      if (searchState !== '') {
        filter.CardName = searchState;
      }
      let url = entity !== undefined ? entity : `base/zone/${zone}/customers`;
      let response = await wsFindBy(url, filter);
      if (response.success) {
        const filteredCustomers = filterByAllowedLetters(response.data);
        setCustomers(filteredCustomers);
      }
    } else {
      let url =
        entity !== undefined
          ? entity
          : saleType === 'O'
          ? `base/zone/${filter.base_zone_id}/customers`
          : 'base/seller/customers';
      let response = await wsFindBy(url, filter);
      if (response.success) {
        const filteredCustomers = filterByAllowedLetters(response.data);
        setCustomers(filteredCustomers);
      }
    }
  }

  useEffect(() => {
    if (open) {
      listCustomers(dataSale);
    }
  }, [open, customerListType, selectedZone]);

  return (
    <ModalFull title="Filtro de clientes" open={open} setOpen={setOpen}>
      <Card>
        <CardHeader icon>
          <CardIcon color={props.themeContext.buttonColor}>
            <Assignment />
          </CardIcon>
          <h4 className={classes.cardIconTitle}>Elija un cliente</h4>

          {(deliveryType === 'O' || saleType === 'O') && (
            <>
              <GridContainer>
                <GridItem xs={3}>
                  <FormControlLabel
                    label={saleType === 'O' ? 'De zonal' : 'De vendedor'}
                    control={
                      <Radio
                        checked={customerListType === 'S'}
                        onClick={() => setCustomerListType('S')}
                      />
                    }
                  />
                  <FormControlLabel
                    label="Todo"
                    control={
                      <Radio
                        checked={customerListType === 'T'}
                        onClick={() => setCustomerListType('T')}
                      />
                    }
                  />
                </GridItem>
                {customerListType === 'T' && (
                  <>
                    {zones.length > 0 && (
                      <GridItem xs={3}>
                        <FormControl fullWidth size="small">
                          <InputLabel>Zona</InputLabel>
                          <Select
                            value={selectedZone || dataSale.base_zone_id || null}
                            onChange={(e) => setSelectedZone(e.target.value)}
                          >
                            {zones.map((item) => {
                              return (
                                <MenuItem value={item.id} key={item.id}>
                                  {item.description}
                                </MenuItem>
                              );
                            })}
                          </Select>
                        </FormControl>
                      </GridItem>
                    )}
                    <GridItem xs={3}>
                      <TextField
                        label="Buscar por nombre"
                        fullWidth
                        value={searchState}
                        onChange={(e) => setSearchState(e.target.value)}
                      />
                    </GridItem>
                    <Button justIcon round color="primary" onClick={() => listCustomers(dataSale)}>
                      <Search />
                    </Button>
                  </>
                )}
              </GridContainer>
            </>
          )}
        </CardHeader>
        <CardBody>
          <ReactTable
            defaultWidth={1100}
            indexRow={[0, 1, 6]}
            widthRow={[80, 120, 0]}
            exportExcel={false}
            columns={columns}
            data={customers.map((item, i) => {
              return {
                num: (
                  <div className="actions-right">
                    <Button
                      justIcon
                      size="sm"
                      round
                      onClick={() => {
                        changeDataSale({
                          CardCode: item.CardCode,
                          ...dataSale,
                          base_business_partner_id: item.id,
                          CardName: item.CardName,
                          base_address_id: item.base_address_id,
                          Address2: item.Address2,
                          base_customer_route_id: item.base_customer_route_id,
                        });
                        setOpen(false);
                      }}
                      color={props.themeContext.buttonColorSuccess}
                    >
                      <Done />
                    </Button>
                  </div>
                ),
                CardCode: item.CardCode,
                CardName: item.CardName,
                LicTradNum: item.LicTradNum,
                Address2: item.Address2,
                state: item.frozenFor === 'N' ? 'Activo' : 'Inactivo',
                actions: '',
              };
            })}
          />
        </CardBody>
      </Card>
    </ModalFull>
  );
});
